import * as React from 'react';
// import Select from 'react-select';
import AsyncSelect from 'react-select/async';

const LazySelect = (props: any) => {
  const customStyles = {
    container: (provided: any, state: any) => ({
      ...provided,
      marginBottom: '0.5rem',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      minHeight: 'auto',
      maxHeight: 33,
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      padding: 5,
    }),
  };

  return <AsyncSelect {...props} styles={customStyles} />;
};

export default LazySelect;
